import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  createCostCenter,
  updateCostCenter,
} from '../../../../../../../lib/api/accounting';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import { showAlert } from '../../../../../../../lib/functions/utils';

interface NewCostCenterProps {
  costCenter: {
    id: string;
    name: string;
  };
  setCostCenter: (costCenter: any) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  setSuccess: (success: string) => void;
  setUp: () => void;
  edit: boolean;
}

const NewCostCenter: React.FC<NewCostCenterProps> = ({
  costCenter,
  setCostCenter,
  open,
  setOpen,
  setSuccess,
  setUp,
  edit,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!costCenter.name.trim()) {
      showAlert(dispatch, 'error', 'El nombre es requerido');
      return;
    }

    setLoading(true);
    try {
      if (edit) {
        await updateCostCenter(dispatch, costCenter.id, {
          name: costCenter.name,
        });
        setSuccess('Centro de costo actualizado correctamente');
      } else {
        await createCostCenter(dispatch, { name: costCenter.name });
        setSuccess('Centro de costo creado correctamente');
      }
      setUp();
      setOpen(false);
      setCostCenter({ id: '', name: '' });
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al guardar el centro de costo');
    }
    setLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
    setCostCenter({ id: '', name: '' });
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {edit ? 'Editar Centro de Costo' : 'Nuevo Centro de Costo'}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nombre"
          type="text"
          fullWidth
          variant="outlined"
          value={costCenter.name}
          onChange={(e) =>
            setCostCenter({ ...costCenter, name: e.target.value })
          }
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={handleClose}
          color="secondary"
          disabled={loading}
        >
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleSubmit} color="primary" disabled={loading}>
          {edit ? 'Actualizar' : 'Crear'}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewCostCenter;
